import '../mainPage.css';
import React, { useState } from 'react';
import { getRandomUser } from './ApiCalls';
import { useNavigate } from 'react-router-dom';

export default function MainPage(){
  const [disabled, setDisabled] = useState(true);
  const navigate = useNavigate();

  function handleSubmit(event) {
    event.preventDefault();
    navigate('/'+event.target.username.value);
    navigate(0);
  }

  function RandomUser(event){
    event.preventDefault();
    getRandomUser().then((event) => {
      navigate('/'+event[0].login);
      navigate(0);
    });
  }

  function handleChange(event) {
    setDisabled(event.target.value === '');
  }

  return(
      <div className ='search-box'>
        <div>
          <form onSubmit={handleSubmit}>
            <label>
              <input type="text" name="username" onChange={handleChange} placeholder="Enter Username..."/>
            </label>
            <input type="submit" value="Search" disabled={disabled}/>
          </form>
        </div>
        <div>
          <p className='center-text'> or </p>
          <button className='button-profile button-box' style={{marginTop: '5px'}} onClick={RandomUser}>Random User</button>
        </div>
      </div>
  );
}